
import React from 'react';

const TestimonialsSection: React.FC = () => {
  const testimonials = [
    {
      name: 'Sr. Vicente',
      theme: 'Benefício por incapacidade temporária (INSS)',
      text: 'Bom dia, doutora. Doutora, pra mim foi um dos melhores trabalhos que eu já assisti alguém fazer por um cliente que estava doente e precisava. E pode... seu trabalho foi excelente.',
      ariaLabel: 'Depoimento de Sr. Vicente — benefício por incapacidade temporária'
    },
    {
      name: 'Maria Lúcia',
      theme: 'Aposentadoria híbrida (tempo rural)',
      text: 'Bom dia Albiana. Se compararmos com valores recebidos por outras pessoas e o fato de ter aposentado com uma idade que ainda pode fazer algo para complementar esse valor, posso dizer que que valeu a pena. A competência, agilidade e conhecimento como foi conduzido todo o processo fez a grande diferença para o êxito obtido.',
      ariaLabel: 'Depoimento de Maria Lúcia — aposentadoria híbrida (tempo rural)'
    },
    {
      name: 'Rivelina Andreuci',
      theme: 'Avaliação pública (Google)',
      text: 'Advogada maravilhosa, competente, rápida, prestativa em tudo apresentando várias possibilidades. Deixei em suas mãos e só tenho que agradecer, em tudo que solicitei fui prontamente atendida e os resultados foram os melhores possíveis. Super …Mais',
      ariaLabel: 'Depoimento de Rivelina Andreuci — avaliação no Google'
    },
    {
      name: 'Telma Carbonera',
      theme: 'Orientações PCD',
      text: 'Albiana me ajudou muito nas orientações com meu filho PCD, nos seus direitos, com seu conhecimento na área estou sempre segura em consultá-la. Gratidão por tudo que fez por nós 🙏🏼',
      ariaLabel: 'Depoimento de Telma Carbonera — avaliação no Google'
    },
    {
      name: 'Sonia Ambrozino da Silva',
      theme: 'Suporte e explicações',
      text: 'Excelente profissional; disponível aos seus clientes, dando todo o suporte e explicação sobre cada processo.',
      ariaLabel: 'Depoimento de Sonia Ambrozino da Silva — avaliação no Google'
    },
    {
      name: 'Yolanda Shizui Aoki',
      theme: 'Isenção de imposto de renda (doenças graves)',
      text: 'Sou Yolanda, aposentada da UEM. Descobri que, por ter tido câncer, tinha direito à isenção da contribuição previdenciária e do imposto de renda. Procurei a doutora Albiana, que me orientou e conduziu todo o processo. Fui muito bem atendida e recomendo seu trabalho pela competência.',
      ariaLabel: 'Depoimento de Yolanda Shizui Aoki — isenção de imposto de renda (doenças graves)'
    }
  ];

  return (
    <section id="depoimentos" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#214134] mb-6">
            Depoimentos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Relatos reais de clientes sobre nosso atendimento jurídico. 
            Conteúdo informativo, sem promessa de resultado.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300"
              aria-label={testimonial.ariaLabel}
            >
              {/* Quote Icon */}
              <div className="w-12 h-12 bg-[#214134] rounded-full flex items-center justify-center mb-6">
                <i className="ri-double-quotes-l text-xl text-[#cc9b3f]"></i>
              </div>
              
              {/* Testimonial Text */}
              <p className="text-gray-700 text-base leading-relaxed mb-6 font-normal">
                "{testimonial.text}"
              </p>
              
              {/* Client Info */}
              <div className="border-t border-gray-100 pt-4">
                <h4 className="text-lg font-bold text-[#214134] mb-1">
                  {testimonial.name}
                </h4>
                <p className="text-sm text-gray-600 font-medium">
                  {testimonial.theme}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
